import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    ward,
    homeNumber,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    agencyContract,
    agencyContractDate,
    documents,
    documentsDate,
    certificate,
    timeSign,
    signer,
    fullName,
  },
} = checkout;

const initialValues = {
  [email.name]: "",
  [phone.name]: "",
  [fax.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [district.name]: "",
  [province.name]: "",
  [ward.name]: "",
  [homeNumber.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [address.name]: "",
  [taxId1.name]: "",
  [taxpayerName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
  [agencyContract.name]: "",
  [agencyContractDate.name]: "",
  [documents.name]: "",
  [documentsDate.name]: "",
};

export default initialValues;
